import { getPageTitle } from 'hb-react/frontoffice/utils/page';
import type { Network } from 'hb-react/types';

interface ApplicationPageTitleProps {
  label: string;
  currentNetwork: Network;
}

export const getApplicationPageTitle = ({
  label,
  currentNetwork,
}: ApplicationPageTitleProps) =>
  getPageTitle({
    title: s__('Mentoring|Apply to become a %{label}').i__({
      label,
    }),
    featureName: '',
    currentNetwork,
  });
